import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { Navigation } from "lucide-react";

const SEND_EVERY_MS = 60000;

export default function LocationSharer() {
  const [jobId, setJobId] = useState(null);
  const [denied, setDenied] = useState(false);
  const lastSent = useRef(0);

  const check = useCallback(() => {
    api.get("/me/active-job").then((r) => setJobId(r.data.job_id)).catch(() => {});
  }, []);

  useEffect(() => {
    check();
    const t = setInterval(check, 120000);
    window.addEventListener("job-status-changed", check);
    return () => { clearInterval(t); window.removeEventListener("job-status-changed", check); };
  }, [check]);

  useEffect(() => {
    if (!jobId || !navigator.geolocation) return undefined;
    lastSent.current = 0;
    const watch = navigator.geolocation.watchPosition(
      (pos) => {
        setDenied(false);
        if (Date.now() - lastSent.current < SEND_EVERY_MS) return;
        lastSent.current = Date.now();
        api.post("/location", { job_id: jobId, lat: pos.coords.latitude, lng: pos.coords.longitude, accuracy: pos.coords.accuracy })
          .catch((e) => { if (e.response?.status === 409) setJobId(null); });
      },
      (err) => { if (err.code === 1) setDenied(true); },
      { enableHighAccuracy: true, maximumAge: 30000, timeout: 20000 },
    );
    return () => navigator.geolocation.clearWatch(watch);
  }, [jobId]);

  if (!jobId) return null;
  return (
    <span data-testid="location-sharing-indicator"
      className={`inline-flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-full border ${denied ? "border-destructive/40 text-destructive bg-destructive/5" : "border-[hsl(140_60%_45%)]/40 text-[hsl(140_60%_32%)] bg-[hsl(140_60%_45%)]/10"}`}>
      <Navigation className="w-3.5 h-3.5" /> {denied ? "Location blocked — allow it in your browser" : "Sharing location (job in progress)"}
    </span>
  );
}
